<template>
  <div v-if="message.type === 'template' && message.template.type === 'carousel'">
    <div class="clearfix"></div>
    <section class="mt-2 mb-3">
      <div class="p-2" v-if="message.template.data_type === 'professional' || message.template.data_type === 'order'">
        <h3 class="mb-0" v-if="message.template.data_type === 'professional'">เลือกผู้ให้บริการ</h3>
        <div class="d-flex" v-if="message.template.data_type === 'order'">
          <div class="flex-fill">
            <h3 class="mb-0">
              การจองของคุณ
              <span v-if="message.template.order_status === 'upcoming'">(ที่กำลังมา)</span>
              <span v-else>(ที่เสร็จสิ้น)</span>
            </h3>
          </div>
          <div class="flex-fill text-right">
            <a href="" @click.prevent="viewOrders('my-reservations-history', txtPast)" class="text-primary-link" v-if="message.template.order_status === 'upcoming'">
              {{ txtPast }} <i class="fas fa-history"></i>
            </a>
            <a href="" @click.prevent="viewOrders('my-reservations', txtUpcoming)" class="text-primary-link" v-else>
              {{ txtUpcoming }}
            </a>
          </div>
        </div>
      </div>
      <!-- Start Carousel -->
      <carousel :perPage="perPage"
                :autoplay="false"
                :centerMode="false"
                :autoplayHoverPause="false"
                :navigationEnabled="false"
                :paginationEnabled="false"
                :loop="false"
                :scrollPerPage="false"
                :mouseDrag="true"
                :touchDrag="true">
        <!-- Profession Carousel -->
        <template v-if="message.template.data_type === 'professional'">
          <slide v-for="(column, index) in message.template.columns" :key="index">
            <div class="card m-2">
              <div class="card-body text-center">
                <img :src="column.thumbnailImageUrl"
                     alt=""
                     class="rounded-circle"
                     width="60" v-if="column.thumbnailImageUrl">
                <div class="mt-2">
                  <div><b>{{ column.title | firstName }}</b></div>
                  <div>{{ globalState.cities[Number(column.data.province_id)] | multiLangName }}</div>
                </div>

                <!-- จะขึ้นใน card ของไม่ระบุผู้ให้บริการ -->
                <div v-if="column.data && !column.data.id">
                  <span style="font-size: 12px;">{{ $t('message.my_reservations.in_case_urgent') }}</span>
                  <hr>
                </div>
                <div class="py-2" v-else>
                  <div v-if="column.data.rating_qty">
                    <span v-html="$options.filters.ratingStar(column.data.rating)"></span>
                    <div>
                      <a href="" class="text-primary-link" @click.prevent="openProfessionalReviewsModal(column.data)">
                        {{ column.data.rating_qty }} {{ $tc('message.professional.review', column.data.rating_qty) }}
                      </a>
                    </div>
                  </div>
                  <hr class="my-2">
                </div>
                <div v-for="(action, index) in column.actions" :key="index">
                  <button type="button"
                          class="btn btn-outline-info btn-block"
                          @click.prevent="sendMessage(action, column.title)">
                    {{ action.text }}
                  </button>
                </div>
              </div>
            </div>
          </slide>
        </template>
        <!-- Order Carousel -->
        <template v-else-if="message.template.data_type === 'order'">
          <slide v-for="(order, index) in message.template.datas" :key="index" v-if="message.template.datas.length > 0">
            <div class="card m-2" :class="order.declined_order_data && order.status === 0 && order.selected_professional_id > 0 ? 'border border-danger' : ''">
              <div class="card-body">

                <div class="d-flex justify-content-start align-items-center mb-2">
                  <div class="flex-fill">
                    #{{ order.order_code }} - <span
                    v-html="$options.filters.serviceParentName(order.service_id, globalState.services)"></span>
                  </div>
                  <div>
                    <span class="text-remark" v-html="$options.filters.orderStatus(order)"></span>
                  </div>
                </div>

                <div class="d-flex justify-content-start align-items-top">
                  <div>
                    <img :src="getProfessionalImage(order)"
                         width="48"
                         class="rounded-circle"
                         :class="order.declined_order_data && order.status === 0 && order.selected_professional_id > 0 ? 'border border-danger' : ''">
                  </div>
                  <div class="flex-fill pl-2">
                    <div v-if="order.user_place">
                      {{ order.user_place.place_name }}
                    </div>
                    <div>
                      <b v-if="order.cleaning_date">{{ order.cleaning_date | prettyDate }}</b>
                      <b v-else>ยังไม่ระบุวันที่รับบริการ</b>
                    </div>
                    <div>
                      <span v-if="order.service_id === 1">
                        {{ order.work_hour }} {{ $tc('message.hour', order.work_hour) }}
                      </span>
                      <span v-if="order.order_service_items && order.order_service_items.length">
                        {{ $t('message.service_item.qty') }} {{ getCountServiceItems(order.order_service_items) }} 
                      </span>
                      <span v-else-if="order.service_id !== 1 && !order.service_request">
                        {{ globalState.services[order.service_id] | multiLangName }}
                      </span>
                      <!-- Check order additional hours -->
                      <span v-if="$options.filters.orderAdditionalHours(order)">
                       {{ order | orderAdditionalHours }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="text-right text-remark">
                  <span class="text-orange" v-if="order.subscription_id">
                    <i class="fal fa-calendar-alt"></i> {{ $t('message.subscription.title') }}
                  </span>
                  <span class="text-orange" v-if="order.package_id">
                    <i class="fal fa-layer-group"></i> {{ order.package.package_type | multiLangName }}
                  </span>
                  <span class="text-orange" v-if="order.host_id">
                    <i class="fal fa-bed"></i> {{ $t('message.my_reservations.for_host') }}
                  </span>
                  <span class="text-orange" v-if="!order.package_id && order.is_no_datetime_booking && order.status < 1">
                    {{ $t('message.booking.new_booking.booking_type_flexible') }}
                  </span>
                </div>

                <div class="pt-3 text-small" v-if="order.service_request">
                  <div v-if="order.service_request.building_address">
                    <i class="fal fa-map-marker-alt"></i>&nbsp;&nbsp;{{ order.service_request.building_address }}
                  </div>
                  <div class="pt-2" v-if="order.service_request.payment_status === 0">
                    <i class="fal fa-file-alt -status-new"></i>&nbsp;&nbsp;{{ $t('message.service_request.service_request_document') }}
                  </div>
                  <hr>
                  <div class="text-order-notification">
                      <span class="bullet-notification-yellow">
                        <i class="fas fa-circle -status-pending"></i>
                      </span>
                    {{ order.service_request.service_request_status | multiLangName }}
                  </div>
                </div>

                <div class="mt-3" v-if="order.paid_status === 1 && order.cleaning_date && !order.confirm_cleaning_date && !order.declined_order_data">
                  <hr>
                  <div class="text-order-notification">
                    <span class="bullet-notification">
                      <i class="fas fa-circle -status-pending"></i>
                    </span>
                    {{ $t('message.my_reservations.no_confirm_cleaning_datetime') }}
                  </div>
                </div>

                <div class="mt-3" v-if="order.declined_order_data && order.status === 0 && order.selected_professional_id > 0">
                  <hr>
                  <div class="text-order-notification">
                    <span class="bullet-notification">
                      <i class="fas fa-circle -status-alert"></i>
                    </span>
                    <span class="-status-alert">
                      {{ $t('message.declined_booking.cleaner_declined_booking') }}
                    </span>
                    <div class="-status-alert mt-1">
                      - {{ order.declined_order_data | declinedReason }}
                    </div>
                  </div>
                </div>

                <!--- Pre-booking professional selection -->
                <div v-if="order.pre_booking_professionals && order.status === 0">
                  <hr>
                  <div class="d-flex justify-content-start align-content-center text-order-notification flex-row flex-wrap">
                    <div>
                      <img src="/static/img/switch_professional.svg">
                    </div>
                    <div class="px-2">
                      {{ $t('message.booking.switch_professional.offer_pre_booking_professionals') }}
                    </div>
                    <div>
                      <span v-for="professional, index in order.pre_booking_professionals">
                        <img class="rounded-circle" 
                            :class="[index === 0 ? 'img-pre-booking-professional-first' : 'img-pre-booking-professional-other']"
                            :src="professional.full_picture" 
                            width="24">
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Job status -->
                <div class="text-order-notification" v-if="order.status === 1 && $options.filters.professionalJobStatus(order, false)">
                  <hr>
                  <div v-html="$options.filters.professionalJobStatus(order, false)"></div>
                </div>

                <div class="text-small" v-if="order.status === 2 && !order.cancel">
                  <hr>
                  <span class="-status-alert">หมายเหตุ</span> คุณสามารถให้ทิปแก่ผู้ให้บริการได้ โดยเข้าไปดูรายละเอียด
                </div>
                <button class="btn btn-outline-info btn-block mt-3" @click="viewOrderDetail(order)">ดูรายละเอียด</button>

                <!-- Received order & review button section -->
                <section v-if="order.status === 2 && !order.cancel">
                  <div v-if="!order.is_received_order && !order.order_report_issue">
                    <hr>
                    <div class="mb-3 text-left text-small">
                      <span class="-status-alert">{{ $t('message.received_order.please_read') }}</span> {{ $t('message.received_order.section_title') }}
                    </div>
                    <button class="btn btn-block btn-info"
                            @click.prevent="openReceivedOrderModal(index, order.id)">
                      {{ $t('message.button.received_order') }}
                    </button>
                  </div>
                  <div v-if="(order.is_received_order || order.order_report_issue) && !order.is_reviewed && order.review_days > 0">
                    <hr>
                    <div class="text-small" v-html="$options.filters.reviewDurationText(order)"></div>
                    <button class="btn btn-info btn-block mt-3"
                            @click.prevent="openReviewModal(index, order.id, order.professional)">
                      {{ $t('message.my_reservations.give_a_review') }}
                    </button>
                  </div>
                  <div class="-status-accepted mt-3" v-if="order.is_received_order && order.is_reviewed">
                    <i class="fas fa fa-check-circle"></i>&nbsp;{{ $t('message.my_reservations.reviewed') }}
                  </div>
                </section>

                <div class="text-remark" v-if="order.order_payment_failure">
                  <hr>
                  <div class="pb-2">
                    <i class="fa fa-exclamation-triangle text-orange"></i>
                    เราไม่สามารถเรียกเก็บเงินจากบัตรของคุณได้เนื่องจาก
                    {{ order.order_payment_failure.failure_message }}
                    คุณสามารถเปลี่ยนชำระเงินด้วยวิธีโอนเงินแทนได้
                  </div>
                  <a href="" class="text-secondary" @click.prevent="changePaymentMethod(order)">
                    <div class="card border-secondary">
                      <div class="card-body p-3">
                        <i class="fal fa-money-bill-wave"></i> {{ $t('message.payment_method.bank_transfer') }}
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </slide>
          <div class="p-4 text-center" v-else>
            <label>ยังไม่มีข้อมูล</label>
          </div>
        </template>
      </carousel>
      <!-- /. carousel -->
    </section>
    <!-- Review Modal -->
    <review-modal ref="reviewModal" @onReviewedOrder="updateOrder('reviewedOrder')" />
    <!-- Received Order Modal -->
    <received-order-modal ref="receivedOrderModal" @onReceivedOrder="updateOrder('receivedOrder')"/>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { Carousel, Slide } from 'vue-carousel'
  import ProfessionalVaccination from '../../professional/components/ProfessionalVaccination'
  import ReviewModal from '../../order/components/ReviewModal'
  import ReceivedOrderModal from '../../order/components/ReceivedOrderModal'

  export default {
    props: {
      message: Object
    },
    components: {
      Carousel,
      Slide,
      ProfessionalVaccination,
      ReviewModal,
      ReceivedOrderModal
    },
    data () {
      return {
        selectedIndex: null,
        perPage: 2.5,
        txtUpcoming: 'การจองที่กำลังมา',
        txtPast: 'การจองที่เสร็จสิ้น'
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState'
      }),
      ...mapState('chatBooking', ['bookingData']),
      hasServiceItems () {
        let hasServiceItems = null
        if (this.bookingData) {
          const parentService = this.globalState.services[this.bookingData.service_id]
          if (parentService && parentService.has_service_items) {
            hasServiceItems = parentService.has_service_items
          }
        }
        return hasServiceItems
      }
    },
    methods: {
      getCountServiceItems (orderServiceItems) {
        let count = 0
        orderServiceItems.forEach(item => {
          count += item.quantity
        })
        return count
      },
      openProfessionalReviewsModal (professional) {
        this.$parent.$parent.openProfessionalReviewsModal(professional)
      },
      changePaymentMethod (order) {
        const message = {
          sender_type: 'user',
          type: 'text',
          label: 'change-payment-bank-transfer',
          text: 'ชำระเงินด้วยวิธีโอนเงิน/Internet Banking',
          data: order
        }
        this.$store.commit('chatBooking/ADD_MESSAGE', message)
      },
      updateOrder (action) {
        if (action === 'receivedOrder') {
          this.message.template.datas[this.selectedIndex].is_received_order = true
        } else if (action === 'reviewedOrder') {
          this.message.template.datas[this.selectedIndex].is_reviewed = true
        }
      },
      openReviewModal (index, orderId, professional) {
        this.selectedIndex = index
        this.$refs.reviewModal.setOrderData(index, orderId, professional.id, professional.full_picture, professional.full_name)
        this.$refs.reviewModal.showReviewModal(true)
      },
      openReceivedOrderModal (index, orderId) {
        this.selectedIndex = index
        this.$refs.receivedOrderModal.setOrderData(index, orderId)
        this.$refs.receivedOrderModal.showReceivedOrderModal(true)
      },
      viewOrders (label, text) {
        let message = {
          sender_type: 'user',
          type: 'text',
          label: label,
          text: text
        }
        this.$store.commit('chatBooking/ADD_MESSAGE', message)
      },
      viewOrderDetail (order) {
        let message = {
          sender_type: 'user',
          type: 'text',
          label: 'view-order-detail',
          text: 'รายละเอียดการจอง',
          data: order
        }
        if (order.service_request) {
          message.label = 'view-service-request-detail'
          message.text = 'รายละเอียดคำขอ'
          message.data = order.service_request
        }
        this.$store.commit('chatBooking/ADD_MESSAGE', message)
      },
      getProfessionalImage (order) {
        let imgUrl = 'https://beneat.co/static/img/unknown.png'
        if (order.professional_id > 0 && order.status > 0) {
          imgUrl = order.professional.full_picture
        } else if (order.professional_id === 0 && order.status === 0 && order.selected_professional_id > 0) {
          imgUrl = order.selected_professional.full_picture
        }
        return imgUrl
      },
      sendMessage (item, title) {
        const itemType = item.type
        const params = new URLSearchParams(item.data)
        const professionalId = Number(params.get('professional_id'))
        const text = (professionalId === 0) ? `${item.text} ${title}` : item.text + ' ' + this.$options.filters.firstName(title)
        switch (itemType) {
          case 'message':
            const message = {
              sender_type: 'user',
              type: 'text',
              label: item.label,
              text: text,
              data: item.data
            }
            this.$store.commit('chatBooking/ADD_MESSAGE', message)
            break
          case 'uri':
            window.open(item.uri, '_blank')
            break
        }
      }
    },
    mounted () {
      if (this.message.template && this.message.template.data_type === 'order') {
        this.perPage = 1.5
      }
    }
  }
</script>

<style scoped>
  .card-body {
    padding: 1rem;
  }
  .vaccine-section {
    font-size: 86%;
  }
</style>



// WEBPACK FOOTER //
// src/components/chatBooking/components/Carousel.vue